import React from 'react';
import { call, takeEvery } from 'redux-saga/effects';
import {
  SystemFilestoreForm,
  mountForm,
  unmountForm,
} from '@kineticdata/react';
import { generateFormButtons, FormError } from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';

const formKey = '/system/setup/infra/filestore';

regRoute('SYSTEM_SETUP_FILESTORE_PAGE', '/system/setup/infra/filestore');

regSaga(
  takeEvery('ENTER_SYSTEM_SETUP_FILESTORE_PAGE', function* () {
    yield call(mountForm, formKey);
  }),
);

regSaga(
  takeEvery('LEAVE_SYSTEM_SETUP_FILESTORE_PAGE', function* () {
    yield call(unmountForm, formKey);
  }),
);

const FormLayout = ({ fields, error, buttons }) => (
  <form>
    <div className="heading heading-sm">
      <h2 className="h3">Filestore Setup</h2>
    </div>
    {fields.toList()}
    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);

export const SystemSetupFilestore = () => (
  <div className="content-container">
    <SystemFilestoreForm
      formKey={formKey}
      components={{
        FormError,
        FormButtons: generateFormButtons({
          submitLabel: 'Update Filestore Settings',
          cancelPath: '/system/setup/config',
        }),
        FormLayout,
      }}
    >
      {({ form }) => form}
    </SystemFilestoreForm>
  </div>
);
